import { fn } from '@/model/common'
import { inBiliApp, isSupport, biliBridge } from '@bilibili/js-bridge'
// eslint-disable-next-line
const { openApp, init, judgeOverSea } = require('@bilibili/h5-utils')

export const isDev =
  process.env.NODE_ENV === 'development' ||
  process.env.VUE_APP_DEPLOY_ENV === 'development'
export const isUat = process.env.NODE_ENV === 'uat'
export const isPre = process.env.NODE_ENV === 'pre'
export const isProd = process.env.NODE_ENV === 'production'

export function webLogin(): void {
  const prefix = `${
    // eslint-disable-next-line
    (<any>window).__ffEnv__?.Front === 'uat' || isUat
      ? 'http://uat-'
      : 'https://'
  }account.bilibili.com/login?gourl=`
  window.location.href = prefix + encodeURIComponent(window.location.href)
}
export const inApp = inBiliApp
const isSafari =
  /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
export const isIos =
  /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(navigator.userAgent) || isSafari

if (!inApp) {
  init()
  judgeOverSea()
}

export function goApp(callUrl?: string): boolean {
  if (isDev) {
    return false
  }
  if (!inBiliApp) {
    const url = callUrl || window.location.href
    let schema = `bilibili://browser?url=${encodeURIComponent(url)}`
    schema = isIos ? encodeURIComponent(schema) : schema
    openApp({
      schema,
      universalLink: url,
      delayDownload: true,
    })
    return true
  } else {
    return false
  }
}

export function toLogin(callback: fn): void {
  if (!inBiliApp) {
    webLogin()
  } else {
    callNative({
      method: 'auth.login',
      data: { type: 'default' },
      onLogin(data: { state: number }) {
        if (Number(data.state) === 1) {
          callback && callback()
        }
      },
      webLogin,
    })
  }
}

export function h5Login() {
  const prefix = 'https://account.bilibili.com/login?gourl='
  location.href = prefix + encodeURIComponent(location.href)
}

// 去登录 native 或者 h5
export function login(callback?: any) {
  if (inApp) {
    callNative(
      {
        method: 'auth.login',
        data: {
          type: 'default',
        },
        onLogin(data: any) {
          if (Number(data.state) === 1) {
            callback && callback()
          }
        },
      },
      true,
      h5Login
    )
  } else {
    h5Login()
  }
}

// eslint-disable-next-line
export function callNative(
  options: any,
  checkMethodSupport = true,
  errCb?: fn
): void {
  if (options.method) {
    if (checkMethodSupport) {
      isSupport(options.method).then((support) => {
        if (support) {
          biliBridge.callNative(options)
        } else {
          errCb && errCb()
        }
      })
    } else {
      biliBridge.callNative(options)
    }
  }
}
